import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { faUsers } from '@fortawesome/pro-duotone-svg-icons';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`hs-navbar navbar navbar-expand-lg fixed-top ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <a className="navbar-brand" href="/" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <span className="brand-icon">
            <FontAwesomeIcon icon={faUsers} />
          </span>
          <span>
            Headstation
            <span className="brand-tagline">Agricultural Operations Technology</span>
          </span>
        </a>

        <button
          className="navbar-toggler border-0"
          type="button"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon icon={open ? faXmark : faBars} style={{ color: '#fff', fontSize: '1.1rem' }} />
        </button>

        <div className={`collapse navbar-collapse ${open ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-1">
            <li className="nav-item">
              <button className="nav-link btn btn-link" onClick={() => scrollTo('services')}>Services</button>
            </li>
            <li className="nav-item">
              <button className="nav-link btn btn-link" onClick={() => scrollTo('solutions')}>Solutions</button>
            </li>
            <li className="nav-item">
              <button className="nav-link btn btn-link" onClick={() => scrollTo('technology')}>Technology</button>
            </li>
            <li className="nav-item ms-lg-2 mt-2 mt-lg-0">
              <button className="btn-hs-primary" onClick={() => scrollTo('contact')}>Get in Touch</button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
